import React from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';
import DashboardCard from './DashboardCard';
import {
  StatValue, StatSub, ProgressTrack, ProgressFill, ListRow, RowMain, RowName,
} from '../styles';

// IdpCompletion — durum dağılımı + tamamlanma oranı. Durum etiketleri
// development-plans/config'teki `performance.idp.status.*` anahtarlarıyla AYNI
// (bağımsız tekrar, tanınmayan durum ham metne düşer).
export default function IdpCompletionCard({ completion, loading }) {
  const { t } = useTranslation();
  const theme = useTheme();

  const empty = !completion || completion.totalPlanCount === 0;

  return (
    <DashboardCard
      title={t('talent.dashboard.idp.title')}
      span={4}
      spanMd={6}
      loading={loading}
      empty={empty}
      emptyText={t('talent.dashboard.idp.empty')}
    >
      {completion && (
        <div>
          <StatValue>{completion.completionPercent}%</StatValue>
          <StatSub>
            {t('talent.dashboard.idp.completed', {
              completed: completion.completedPlanCount,
              total: completion.totalPlanCount,
            })}
          </StatSub>
          <ProgressTrack style={{ marginTop: 10, marginBottom: 6 }}>
            <ProgressFill $pct={completion.completionPercent} $color={theme.colors.primary.dark} />
          </ProgressTrack>
          <div>
            {(completion.byStatus || []).map((s) => (
              <ListRow key={s.status}>
                <RowMain><RowName>{t(`performance.idp.status.${s.status}`, { defaultValue: s.status })}</RowName></RowMain>
                <StatSub>{s.count}</StatSub>
              </ListRow>
            ))}
          </div>
        </div>
      )}
    </DashboardCard>
  );
}
